export default "__VITE_ASSET__CKit18ia__"